/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TextMessageStepOverrideTaskNoteDoc } from './textMessageStepOverrideTaskNoteDoc';

export interface TextMessageStepOverride {
  type: 'text_message';
  task_note_doc?: TextMessageStepOverrideTaskNoteDoc;
}
